"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _nanoid = require("nanoid");

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The Accordion component delivers a group of large amounts of content in a small space through progressive disclosure.
 * Accordions are useful when you want to toggle between hiding and showing large amount of content
 *
 * The header title give the user a high level overview of the content allowing the user to decide which sections to read.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */
const Accordion = /*#__PURE__*/React.forwardRef(({
  list,
  gutter,
  variant,
  content,
  ...otherProps
}, ref) => {
  const [expandId, setExpandId] = React.useState(null);
  return (0, _pragma.createFelaElement)(_.View, _extends({
    ref: ref,
    flex: true,
    flexDirection: "column"
  }, otherProps), list.map((item, idx) => (0, _pragma.createFelaElement)(_.ExpansionPanel, {
    key: item.id || (0, _nanoid.nanoid)(),
    variant: variant,
    gutter: gutter,
    title: item.title,
    content: content(item),
    expandExternally: expandId === idx,
    setExpandExternally: () => {
      if (idx === expandId) setExpandId(null);else setExpandId(idx);
    }
  })));
});
Accordion.displayName = 'Accordion';
var _default = Accordion;
exports.default = _default;
//# sourceMappingURL=Accordion.js.map